import { useState, useEffect } from 'react';
import { PortfolioItem } from '../types';

const STORAGE_KEY = 'blockpeek_portfolio';

export const usePortfolio = () => {
  const [portfolio, setPortfolio] = useState<PortfolioItem[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        setPortfolio(JSON.parse(saved));
      } catch (error) {
        console.error('Error loading portfolio:', error);
      }
    }
  }, []);

  const addToPortfolio = (item: PortfolioItem) => {
    const updated = [...portfolio, item];
    setPortfolio(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  const removeFromPortfolio = (coinId: string) => {
    const updated = portfolio.filter((item) => item.coinId !== coinId);
    setPortfolio(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  const updatePortfolio = (coinId: string, amount: number) => {
    const updated = portfolio.map((item) =>
      item.coinId === coinId ? { ...item, amount } : item
    );
    setPortfolio(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  const clearPortfolio = () => {
    setPortfolio([]);
    localStorage.removeItem(STORAGE_KEY);
  };

  return {
    portfolio,
    addToPortfolio,
    removeFromPortfolio,
    updatePortfolio,
    clearPortfolio,
  };
};